import { Folder } from '@/modules/file/components/folder-nav/types'

export const folderCount = (folders: Folder[]): number => {
  let count = 0
  folders.forEach((folder) => {
    count += 1
    if (folder.children.length > 0) {
      count += folderCount(folder.children)
    }
  })
  return count
}
